const APP_CONFIG = {
    'account_types': {
        1: 'Internal',
        2: 'Live'
    },
    'account_status_opt':{
        1: 'Active',
        0: 'Inactive'
    },
    'region_options': {
        'north_america' : 'North America',
        'europe' : 'Europe',
        'asiapacific' : 'Asia-Pacific',                
        'middle_east_africa' : 'Middle East & Africa',
        'south_america' : 'South America',
    },
    'country_options': {
        "AF" :	"Afghanistan",
        "AX" :	"Aland Islands",
        "AL" :	"Albania",
        "DZ" :	"Algeria",
        "AS" :	"American Samoa",
        "AD" :	"Andorra",
        "AO" :	"Angola",
        "AI" :	"Anguilla",
        "AG" :	"Antigua and Barbuda",
        "AR" :	"Argentina",
        "AM" :	"Armenia",
        "AW" :	"Aruba",
        "AU" :	"Australia",
        "AT" :	"Austria",
        "AZ" :	"Azerbaijan",
        "BS" :	"Bahamas",
        "BH" :	"Bahrain",
        "BD" :	"Bangladesh",
        "BB" :	"Barbados",
        "BY" :	"Belarus",
        "BE" :	"Belgium",
        "BZ" :	"Belize",
        "BJ" :	"Benin",
        "BM" :	"Bermuda",
        "BT" :	"Bhutan",
        "BO" :	"Bolivia",
        "BA" :	"Bosnia and Herzegovina",
        "BW" :	"Botswana",
        "BR" :	"Brazil",
        "VG" :	"British Virgin Islands",
        "BN" :	"Brunei",
        "BG" :	"Bulgaria",
        "BF" :	"Burkina Faso",
        "BI" :	"Burundi",
        "KH" :	"Cambodia",
        "CM" :	"Cameroon",
        "CA" :	"Canada",
        "CV" :	"Cape Verde",
        "KY" :	"Cayman Islands",
        "CF" :	"Central African Republic",
        "TD" :	"Chad",
        "CL" :	"Chile",
        "CN" :	"China",
        "CX" :	"Christmas Island",
        "CO" :	"Colombia",
        "KM" :	"Comoros",
        "CR" :	"Costa Rica",
        "CI" :	"Cote D'Ivoire",
        "HR" :	"Croatia",
        "CU" :	"Cuba",
        "CY" :	"Cyprus",
        "CZ" :	"Czech Republic",
        "CG" :	"Democratic Republic Of The Congo",
        "DK" :	"Denmark",
        "DJ" :	"Djibouti",
        "DM" :	"Dominica",
        "DO" :	"Dominican Republic",
        "EC" :	"Ecuador",
        "EG" :	"Egypt",
        "SV" :	"El Salvador",
        "GQ" :	"Equatorial Guinea",
        "ER" :	"Eritrea",
        "EE" :	"Estonia",
        "SZ" :	"Eswatini",
        "ET" :	"Ethiopia",
        "FM" :	"Federated States Of Micronesia",
        "FJ" :	"Fiji",
        "FI" :	"Finland",
        "FR" :	"France",
        "GA" :	"Gabon",
        "GM" :	"Gambia",
        "GE" :	"Georgia",
        "DE" :	"Germany",
        "GH" :	"Ghana",
        "GR" :	"Greece",
        "GD" :	"Grenada",
        "GT" :	"Guatemala",
        "GN" :	"Guinea",
        "GW" :	"Guinea-Bissau",
        "GY" :	"Guyana",
        "HT" :	"Haiti",
        "HN" :	"Honduras",
        "HK" :	"Hong Kong",
        "HU" :	"Hungary",
        "IS" :	"Iceland",
        "IN" :	"India",
        "ID" :	"Indonesia",
        "IR" :	"Iran",
        "IQ" :	"Iraq",
        "IE" :	"Ireland",
        "IL" :	"Israel",
        "IT" :	"Italy",
        "JM" :	"Jamaica",
        "JP" :	"Japan",
        "JO" :	"Jordan",
        "KZ" :	"Kazakhstan",
        "KE" :	"Kenya",
        "KI" :	"Kiribati",
        "XK" :	"Kosovo",
        "KW" :	"Kuwait",
        "KG" :	"Kyrgyzstan",
        "LA" :	"Laos",
        "LV" :	"Latvia",
        "LB" :	"Lebanon",
        "LS" :	"Lesotho",
        "LR" :	"Liberia",
        "LY" :	"Libya",
        "LI" :	"Liechtenstein",
        "LT" :	"Lithuania",
        "LU" :	"Luxembourg",
        "MK" :	"Macedonia",
        "MG" :	"Madagascar",
        "MW" :	"Malawi",
        "MY" :	"Malaysia",
        "MV" :	"Maldives",
        "ML" :	"Mali",
        "MT" :	"Malta",
        "MH" :	"Marshall Islands",
        "MR" :	"Mauritania",
        "MU" :	"Mauritius",
        "MX" :	"Mexico",
        "MD" :	"Moldova",
        "MC" :	"Monaco",
        "MN" :	"Mongolia",
        "ME" :	"Montenegro",
        "MA" :	"Morocco",
        "MZ" :	"Mozambique",
        "MM" :	"Myanmar",
        "NA" :	"Namibia",
        "NR" :	"Nauru",
        "NP" :	"Nepal",
        "NL" :	"Netherlands",
        "NZ" :	"New Zealand",
        "NI" :	"Nicaragua",
        "NE" :	"Niger",
        "NG" :	"Nigeria",
        "KP" :	"North Korea",
        "PS" :	"North Macedonia",
        "NO" :	"Norway",
        "OM" :	"Oman",
        "PK" :	"Pakistan",
        "PW" :	"Palau",
        "PS" :	"Palestine",
        "PA" :	"Panama",
        "PG" :	"Papua New Guinea",
        "PY" :	"Paraguay",
        "PE" :	"Peru",
        "PH" :	"Philippines",
        "PL" :	"Poland",
        "PT" :	"Portugal",
        "QA" :	"Qatar",
        "CG" :	"Republic Of The Congo",
        "RO" :	"Romania",
        "RU" :	"Russia",
        "RW" :	"Rwanda",
        "KN" :	"Saint Kitts and Nevis",
        "LC" :	"Saint Lucia",
        "VC" :	"Saint Vincent and Grenadines",
        "WS" :	"Samoa",
        "SM" :	"San Marino",
        "ST" :	"Sao Tome and Principe",
        "SA" :	"Saudi Arabia",
        "SN" :	"Senegal",
        "RS" :	"Serbia",
        "SC" :	"Seychelles",
        "SL" :	"Sierra Leone",
        "SG" :	"Singapore",
        "SK" :	"Slovakia",
        "SI" :	"Slovenia",
        "SB" :	"Solomon Islands",
        "SO" :	"Somalia",
        "ZA" :	"South Africa",
        "KR" :	"South Korea",
        "SS" :	"South Sudan",
        "ES" :	"Spain",
        "LK" :	"Sri Lanka",
        "SD" :	"Sudan",
        "SR" :	"Suriname",
        "SE" :	"Sweden",
        "CH" :	"Switzerland",
        "SY" :	"Syria",
        "TW" :	"Taiwan",
        "TJ" :	"Tajikistan",
        "TZ" :	"Tanzania",
        "TH" :	"Thailand",
        "TL" :	"Timor-Leste",
        "TG" :	"Togo",
        "TK" :	"Tokelau",
        "TO" :	"Tonga",
        "TT" :	"Trinidad and Tobago",
        "TN" :	"Tunisia",
        "TR" :	"Turkey",
        "TM" :	"Turkmenistan",
        "TC" :	"Turks and Caicos Islands",
        "TV" :	"Tuvalu",
        "VI" :	"U.S. Virgin Islands",
        "UG" :	"Uganda",
        "UA" :	"Ukraine",
        "AE" :	"United Arab Emirates",
        "GB" :	"United Kingdom",
        "US" :	"United States",
        "UM" :	"United States Minor Outlying Islands",
        "UY" :	"Uruguay",
        "UZ" :	"Uzbekistan",
        "VU" :	"Vanuatu",
        "VA" :	"Vatican City",
        "VE" :	"Venezuela",
        "VN" :	"Vietnam",
        "WF" :	"Wallis and Futuna Islands",
        "EH" :	"Western Sahara",
        "YE" :	"Yemen",
        "ZM" :	"Zambia",
        "ZW" :	"Zimbabwe"
    },
    'company_domains' : {
        'Aerospace & Defence' : 'Aerospace & Defence',
        'Agriculture' : 'Agriculture',
        'Automotive & Transportation' : 'Automotive & Transportation',
        'Chemicals & Material' : 'Chemicals & Material',
        'Energy & Power' : 'Energy & Power',
        'Food & Beverage' : 'Food & Beverage',
        'Healthcare' : 'Healthcare',
        'Information & Communications Technology' : 'Information & Communications Technology',
        'Packaging, Construction, Mining & Gases' : 'Packaging, Construction, Mining & Gases',
        'Private Equity/Financial Services' : 'Private Equity/Financial Services',
        'Research Institute/University' : 'Research Institute/University',
        'Research/Consulting/Business Services' : 'Research/Consulting/Business Services',
        'Semiconductor & Electronics' : 'Semiconductor & Electronics'
    },
    'user_roles': {
        '24': 'Super Admin',
        '25': 'Analyst',
        '26': 'Client',
    },
    'user_status_options':{
        1: 'Active',
        0: 'Inactive'
    },
    'AVATAR_URL' : 'https://ui-avatars.com/api/?',
    'randomIconClasses' : [
        'purple_strat',
        'green_strat',
        'magenta_strat',
        'orange_strat',
        'blue_strat'
    ],
    'randomBarClasses' : [
        'purple',
        'green',
        'yellow',
        'magenta'
    ]
};

export default APP_CONFIG;
